import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useParams } from "react-router-dom";

import { fetchDealRoomActiveChatUser } from "src/redux/actions/dealRoom";
import ChatSection from "src/pages/dealRoom/components/chat/chatContainer/chatSection";
import ChatInput from "src/pages/dealRoom/components/chat/chatContainer/chatInput";
import UserDetails, { PlaceholderUserDetails } from "../userDetails";
import { DealRoomContext } from "../../context";

import styles from "./styles.module.scss";

const ChatContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { conversationId } = useParams();
  const chatUserId = conversationId ?? '';

  const { dealRoom } = useContext(DealRoomContext);
  const dealRoomId = _.get(dealRoom, 'id', '');

  const chatUserData = useSelector((state: any) => {
    return _.get(state, `dealRooms.dealRoom.${dealRoomId}.engage.activeChatUser`, null);
  });
  const activeChatUser = _.get(chatUserData, 'item', {});
  const chatUserLoading = _.get(chatUserData, 'loading', false);

  useEffect(() => {
    dispatch(fetchDealRoomActiveChatUser({
      dealRoomId,
      chatUserId
    }));
  }, [chatUserId]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {
          !chatUserLoading ? (
            <UserDetails user={activeChatUser} showHighlights={false} />
          ) : (
            <div className={styles.loadingContainer}>
              <PlaceholderUserDetails />
            </div>
          )
        }
      </div>

      <div className={styles.divider}></div>

      <ChatSection />

      <ChatInput />
    </div>
  );
}

export default ChatContainer;